import { parseNullableValue } from '@clearverify/utils';

import {
  PeoPayrollProvidersSimpleListQuery,
  PeoPayrollProvidersSimpleListQueryVariables,
  usePeoPayrollProvidersSimpleListQuery,
} from 'src/api';

import { QueryParamsVariables, useAutocompleteFieldWithQuery } from '../forms';

export const usePeoPayrollProvidersAutocomplete = (
  paramVariables: QueryParamsVariables<
    PeoPayrollProvidersSimpleListQuery,
    PeoPayrollProvidersSimpleListQueryVariables
  > = {},
) => {
  return useAutocompleteFieldWithQuery(
    usePeoPayrollProvidersSimpleListQuery,
    {
      getQueryItems: data => data?.peoPayrollProviderList,
      ...paramVariables,
    },
    {
      getOptionLabel: option => parseNullableValue(option.displayName),
    },
  );
};
